<template>
  <div id="future">
    <img id="heron1" src="../assets/heron1.svg" />
    <img id="heron3" src="../assets/heron3.svg" />
    <img id="heron2" src="../assets/heron2.svg" />
    <div id="acknowledgements">
      <h4>Acknowledgments</h4>
      <p>This essay was written by Janice Yamanaka in partial fulfillment of the requirements for the degree of Master of Science in Data Visualization, at Parsons School of Design | The New School. Thank you to the professors at Parsons: Aaron Hill, Daniel Sauter, Christian Swinehart, Richard The and Alec Barrett; and both of the graduate classes of 2019/20.</p>

      <p>Data was mostly collected from US governmental organizations, including: the New Jersey Department of Environmental Protection's Bureau of GIS (NJDEP GIS) Land Open Data, the U.S. Geological Survey (USGS), National Water Information System, the U.S. Fish and Wildlife Service (FWS), Spotify, and the Internet Movie Database (IMDB) for which you can find the direct links to the data in the sources section below.</p>

      <p>This visual essay was built with Vue CLI 3, D3, and Mapbox Studio. I also used the help of the XXXX scroll.js library for scroll events.</p>

      <p>A special thanks to my children, Kian, Cole and Galen for always keeping it real and always giving critical and constructive evaluations of my work (and my frame of mind).</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FutureSection',
}
</script>
<style>
#future {
  position: absolute;
  left: 15300px;
  top: 0px;
  height: 100vh;
  text-align: start;
}
@keyframes liftoff {
  0% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(700px, -500px);
  }
}
@keyframes liftoff2 {
  0% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(800px, -500px);
  }
}
@keyframes liftoff3 {
  0% {
    transform: translate(0px, 0px);
    opacity: 1;
  }
  70% {
    opacity: 0.1;
  }
  100% {
    transform: translate(1200px, -500px);
    opacity: 0;
  }
}
#future #heron1 {
  width: 243px;
  position: absolute;
  top: -25px;
  left: -260px;
  animation: liftoff 10s 1s ease-out infinite;
}
#future #heron2 {
  width: 183px;
  position: absolute;
  top: 290px;
  left: -210px;
  animation: liftoff2 10s 2s ease-out infinite;
}
#future #heron3 {
  width: 203px;
  position: absolute;
  top: 225px;
  left: -80px;
  animation: liftoff3 10s 3s ease-out infinite;
}
#future #acknowledgements {
  position: absolute;
  bottom: 30px;
  left: 0px;
  width: 640px;
  background-color: white;
  padding-left: 1rem;
}
#future #acknowledgements h4 {
  font-size: 16pt;
  color: var(--hydrology-blue);
  text-transform: uppercase;
}
#future #acknowledgements p {
  font-size: 11pt;
  line-height: 16pt;
}
</style>
